import { Mappable, Mapped } from '../../rest/decorators/mapped'
import { mapMorphable, Morphable } from '../../rest/utilities/morphable'
import { RestQuery } from '../../rest/utilities/rest-query'
import { JobAllocation } from '../../work/models/job-allocation'
import { SalesPurchaseOrder } from '../../work/models/sales-purchase-order'
import { User } from './user'

@Mapped(
  {
    user: { format: User.create },
    subject: { format: mapMorphable },
    dismissed_at: { property: 'dismissed', type: 'date' },
  },
  ['numericID', 'timestamps']
)
export class Notification extends Mappable {
  id!: string
  numericID!: number
  ulid!: string
  title!: string
  action!: string
  user!: User | null
  subject?: Morphable
  dismissed!: Date | null
  created!: Date
  updated!: Date

  static create<Data>(attrs: Data) {
    return new Notification().map(attrs)
  }

  get salesPurchaseOrder(): SalesPurchaseOrder | null {
    return this.subject?.type === 'salesPurchaseOrder'
      ? SalesPurchaseOrder.create(this.subject?.data)
      : null
  }

  get jobAllocation(): JobAllocation | null {
    return this.subject?.type === 'jobAllocation'
      ? JobAllocation.create(this.subject.data)
      : null
  }
}

export interface Filters {
  mine?: boolean
  pending?: boolean
  action?: 'allocationMoved' | 'estimateSalesOrder' | 'bookSalesOrder'
}
export type Ordering = 'created_at' | '-created_at'
export type Includes = 'subject' | 'user'

export class NotificationQuery extends RestQuery<Filters, Ordering, Includes> {}
